<div class="docs-section" id="making-a-call">
  <div class="docs-section__head">
    <h1 class="docs-h1">Making a call</h1>
    <p class="docs-subtitle">The body is nested, not flat: parameters live inside a request or response envelope.</p>
  </div>

  <div class="docs-example-row">
    <div class="docs-code-panel">
      <div class="docs-code-panel__header">
        <div class="docs-code-tabs">
          @for (lang of languages; track lang.id) {
            <button type="button" class="docs-code-tab" [class.docs-code-tab--active]="activeLang() === lang.id" (click)="setLang(lang.id)">{{ lang.label }}</button>
          }
        </div>
        <button type="button" class="docs-copy-btn" [class.docs-copy-btn--copied]="copied" (click)="copyCallExample()">
          @if (copied) {
            Copied
          } @else {
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 00-2 2v6a2 2 0 002 2h5a2 2 0 002-2V6.828a2 2 0 00-.586-1.414l-2.828-2.828A2 2 0 008.172 2H6Z" fill="currentColor"/><path d="M3 5a1 1 0 00-1 1v7a2 2 0 002 2h6a1 1 0 100-2H4V6a1 1 0 00-1-1Z" fill="currentColor"/></svg>
            Copy
          }
        </button>
      </div>
      <pre class="docs-code-pre" [innerHTML]="callExampleHtml"></pre>
    </div>

    <aside class="docs-aside">
      <p class="docs-aside__title">Envelopes</p>
      <div class="docs-aside__item">
        <span class="docs-param">request</span>
        <p class="docs-subtitle">What to search.</p>
      </div>
      <div class="docs-aside__item">
        <span class="docs-param">response</span>
        <p class="docs-subtitle">How much to return, and in what shape.</p>
      </div>
      <p class="docs-subtitle">
        Only send the envelopes you're using. An absent envelope falls back to the upstream defaults; an
        empty one behaves the same way, but looks like a deliberate choice.
      </p>
    </aside>
  </div>

  <div class="docs-section__head">
    <h2 class="docs-h2" id="response-headers">Response headers</h2>
    <p class="docs-subtitle">
      Responses are relayed from the upstream verbatim. Cikisi wraps every payload as
      <code class="docs-param">&#123; data, messages, success &#125;</code>. The response schemas documented in the
      <a class="link" routerLink="/docs/api-reference">API reference</a> describe <code class="docs-param">data</code>.
      Three headers are added on the way out:
    </p>
  </div>

  <div class="docs-table-wrap">
    <table class="docs-table">
      <thead><tr><th class="docs-table__col-header">Header</th><th>Meaning</th></tr></thead>
      <tbody>
        <tr><td><span class="docs-param">X-Request-Cost-Cents</span></td><td>What this call cost.</td></tr>
        <tr><td><span class="docs-param">X-Wallet-Balance-Cents</span></td><td>Balance the call was authorized against.</td></tr>
        <tr><td><span class="docs-param">X-Wallet-Currency</span></td><td>Currency of that balance.</td></tr>
      </tbody>
    </table>
  </div>
</div>
